module.exports = __webpack_public_path__ + "img/ia-04-5.d22131b5.png";